export default {
  momentLocale: 'en',
  Timeline: {
    expand: 'Expand',
    fold: 'Fold',
  },
  Balloon: {
    close: 'Close',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
  Card: {
    expand: 'Expand',
    fold: 'Fold',
  },
  Calendar: {
    today: 'Today',
    now: 'Now',
    ok: 'OK',
    clear: 'Clear',
    month: 'Month',
    year: 'Year',
    prevYear: 'Previous Year',
    nextYear: 'Next Year',
    prevMonth: 'Previous Month',
    nextMonth: 'Next Month',
    prevDecade: 'Previous Twelve Years',
    nextDecade: 'Next Twelve Years',
    yearSelectAriaLabel: 'Select Year',
    monthSelectAriaLabel: 'Select Month',
  },
  DatePicker: {
    placeholder: 'Select Date',
    datetimePlaceholder: 'Select Date And Time',
    monthPlaceholder: 'Select Month',
    yearPlaceholder: 'Select Year',
    now: 'Now',
    selectTime: 'Select Time',
    selectDate: 'Select Date',
    ok: 'OK',
    clear: 'Clear',
    startPlaceholder: 'Start Date',
    endPlaceholder: 'End Date',
    hour: 'H',
    minute: 'M',
    second: 'S',
  },
  Dialog: {
    close: 'Close',
    ok: 'OK',
    cancel: 'Cancel',
  },
  Message: {
    closeAriaLabel: 'Close',
  },
  Pagination: {
    goTo: 'Go to',
    page: 'Page',
    total: 'Page {current}, {total} pages',
    labelPrev: 'Previous page, current page {current}',
    labelNext: 'Next page, current page {current}',
    inputAriaLabel: 'Please enter what page to skip to',
    selectAriaLabel: 'Please select how many items are displayed on each page',
    pageSize: 'items/page',
  },
  Input: {
    clear: 'Clear',
  },
  Select: {
    selectPlaceholder: 'Please Select',
    autoCompletePlaceholder: 'Please Input',
    notFoundContent: 'No Options',
    maxTagPlaceholder: 'Selected {selected}/{total} Total',
  },
  Table: {
    empty: 'No Data',
    ok: 'OK',
    reset: 'Reset',
    asc: 'Ascending Order',
    desc: 'Descending Order',
    expanded: 'Expanded',
    folded: 'Folded',
    filter: 'Filter',
    selectAll: 'Select All',
  },
  TimePicker: {
    placeholder: 'Select Time',
    startPlaceholder: 'Start Time',
    endPlaceholder: 'End Time',
    clear: 'Clear',
    hour: 'H',
    minute: 'M',
    second: 'S',
  },
  Transfer: {
    items: 'items',
    item: 'item',
    moveAll: 'Move All',
    searchPlaceholder: 'Please Input',
    moveToLeft: 'Uncheck Selected Elements',
    moveToRight: 'Submit Selected Elements',
  },
  Upload: {
    card: {
      cancel: 'Cancel',
      addPhoto: 'Add Picture',
      download: 'Download',
      delete: 'Delete',
    },
    drag: {
      text: 'Click or Drag the file to this area to upload',
      hint: 'Support docx, xls, PDF, rar, zip, PNG, JPG and other files upload',
    },
    upload: {
      delete: 'Delete',
    },
  },
  Search: {
    buttonText: 'Search',
  },
  Tag: {
    delete: 'Delete',
  },
  Rating: {
    description: 'Rating Options',
  },
};
